import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full min-h-[580px] md:min-h-[680px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20clean%20minimalist%20flat%20lay%20of%20fashion%20items%20on%20a%20soft%20cream%20background%2C%20featuring%20sneakers%2C%20hoodie%2C%20bag%2C%20and%20accessories%20arranged%20in%20an%20artistic%20composition%2C%20soft%20natural%20lighting%2C%20gentle%20pastel%20and%20warm%20neutral%20tones%2C%20editorial%20aesthetic%2C%20high%20detail%2C%20clean%20and%20airy%20mood&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="CSSBuy Spreadsheet fashion collection flat lay"
          className="w-full h-full object-cover object-center"
          title="CSSBuy Spreadsheet Hub - Fashion Collection"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35"></div>
      </div>

      <div className="relative w-full px-4 md:px-10 lg:px-16 z-10">
        <div className="max-w-3xl">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-6">
            <span className="w-2 h-2 rounded-full bg-accent-500 animate-pulse"></span>
            <span className="text-xs text-background-50/90 font-label tracking-wide uppercase">The #1 Spreadsheet Hub for Chinese Agents</span>
          </div>

          <h1 className="font-heading font-bold text-4xl md:text-6xl lg:text-7xl text-background-50 leading-[1.05] mb-4">
            The Largest
            <br />
            <span className="text-primary-400">Spreadsheet Hub</span>
          </h1>

          <p className="text-background-50/80 text-base md:text-lg max-w-lg mb-8 leading-relaxed">
            Your central destination for curated CSSBuy spreadsheet links, trusted seller lists, and comprehensive shopping agent guides — all in one beautifully organized hub.
          </p>

          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-primary-500 text-background-50 font-label font-semibold text-sm rounded-full hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer group"
            >
              cssbuy sheet
              <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
            </a>
            <Link
              to="/cssbuy-sheet-guide"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 bg-background-50/15 backdrop-blur-sm border border-background-50/30 text-background-50 font-label font-semibold text-sm rounded-full hover:bg-background-50/25 transition-all whitespace-nowrap cursor-pointer"
            >
              Read the Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="flex flex-wrap items-center gap-6 mt-10">
            <div className="flex items-center gap-2">
              <span className="font-heading font-bold text-2xl md:text-3xl text-background-50">14+</span>
              <span className="text-xs text-background-50/70 leading-tight">Product<br />Categories</span>
            </div>
            <div className="w-px h-8 bg-background-50/20"></div>
            <div className="flex items-center gap-2">
              <span className="font-heading font-bold text-2xl md:text-3xl text-background-50">10K+</span>
              <span className="text-xs text-background-50/70 leading-tight">Curated<br />Products</span>
            </div>
            <div className="w-px h-8 bg-background-50/20"></div>
            <div className="flex items-center gap-2">
              <span className="font-heading font-bold text-2xl md:text-3xl text-background-50">100+</span>
              <span className="text-xs text-background-50/70 leading-tight">Trusted<br />Sellers</span>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-16 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}